export function unwrap(collection) {
    return collection === null || collection === void 0 ? void 0 : collection.edges.map(edge => edge.node);
}
